<template>
  <div class="newFooter">
    <div class="newFooter-con-top">
      <div class="con-left">
        <div class="con-left-item">
          <div class="con-left-item-title">新闻资讯</div>
          <div
            class="con-left-item-sub"
            v-for="(item, i) in xwzx"
            :key="i"
            @click="clickXWZX(item.index)"
          >{{ item.name }}</div>
        </div>
        <div class="con-left-item">
          <div class="con-left-item-title">创新服务</div>
          <div
            class="con-left-item-sub"
            v-for="(item, index) in cxfw"
            :key="index"
            @click="clickCXFW(item.code)"
          >{{ item.name }}</div>
        </div>
        <div class="con-left-item">
          <div class="con-left-item-title">人才服务</div>
          <div
            class="con-left-item-sub"
            v-for="(item, index) in rcfw"
            :key="index"
            @click="clickRCFW(item.code)"
          >{{ item.name }}</div>
        </div>
        <div class="con-left-item">
          <div class="con-left-item-title">企业诊断</div>
          <div
            class="con-left-item-sub"
            v-for="(item, index) in qyzd"
            :key="index"
            @click="clickQYZD(item.code)"
          >{{ item.name }}</div>
        </div>
        <div class="con-left-item">
          <div class="con-left-item-title">资源池</div>
          <div
            class="con-left-item-sub"
            v-for="(item, index) in zyc"
            :key="index"
            @click="clickZYC(item.code)"
          >{{ item.name }}</div>
        </div>
        <div class="con-left-item">
          <div class="con-left-item-title">公共服务</div>
          <div
            class="con-left-item-sub"
            v-for="(item, index) in ggfw"
            :key="index"
            @click="clickGGFW(item.id)"
          >{{ item.program }}</div>
        </div>
        <div class="con-left-item">
          <div class="con-left-item-title">特色服务</div>
          <div
            class="con-left-item-sub"
            v-for="(item, index) in tsfw"
            :key="index"
            @click="clickTSFW(item.id)"
          >{{ item.program }}</div>
        </div>
        <div class="con-left-item">
          <div class="con-left-item-title">协议规则</div>
          <div
            class="con-left-item-sub"
            v-for="(item, index) in xygz"
            :key="index"
            @click="otherUrl(item.url)"
          >{{ item.title }}</div>
        </div>
      </div>
      <div class="devideLine"></div>
      <div class="con-right">
        <div class="con-right-title">联系我们</div>
        <div class="con-right-sub">客服电话：{{ tel }}</div>
        <div class="con-right-sub">客服邮箱：{{ email }}</div>
        <div class="con-right-code" :style="{ backgroundImage: `url(${code})` }"></div>
        <div class="attention">关注公众号</div>
      </div>
    </div>
    <div class="newFooter-con-center flex">
      友情连接：
      <span
        v-for="item in connectList"
        :key="item.title"
        @click="otherUrl(item.url)"
        class="curp"
      >{{ item.title }}</span>
    </div>
    <div class="newFooter-con-bottom">
      <div class="mark1">
        <div>主办单位：宁夏回族自治区工业和信息化厅</div>
        <div>建设单位：共享智能铸造产业创新中心有限公司</div>
      </div>
      <div class="mark2">
        © 2024 All rights reserved 共享智能铸造产业创新中心有限公司  <span style="cursor: pointer;" @click="otherUrl(baUrl)">宁ICP备17001391号-8</span>
      </div>
    </div>
  </div>
</template>

<script>
import { getNewsProgramTreeList, getTypeCount } from "@/utils/interface";
export default {
  name: "",
  components: {},
  props: {},
  data() {
    return {
      xwzx: ["资讯公告", "政策文件", "知产资讯", "赛事活动"],
      cxfw: [
        { name: "知产创造", code: "1" },
        { name: "知产运用", code: "2" },
        { name: "知产保护", code: "3" },
        { name: "知产服务", code: "4" },
        { name: "项目申报", code: "5" },
        { name: "标准管理", code: "6" }
      ],
      rcfw: [
        { name: "在线课程", code: "1" },
        { name: "线下培训", code: "2" },
        { name: "职称申报", code: "3" },
        { name: "继续教育", code: "4" }
      ],
      qyzd: [
        { name: "智能制造评估", code: "1" },
        { name: "两化融合评估", code: "2" },
        { name: "企业上云评估", code: "3" },
        { name: "填报培训", code: "4" }
      ],
      zyc: [
        { name: "服务商资源", code: "1" },
        { name: "专家库", code: "2" }
      ],
      ggfw: [
        "人力资源",
        "行政管理",
        "财务管理",
        "营销管理",
        "采购管理",
        "生产管理",
        "技术质量"
      ],
      tsfw: ["装备制造业", "化工行业", "冶金行业", "新材料", "其他行业"],
      xygz: [
        {
          title: "隐私政策",
          url: "https://www.fuzhiqiangqi.com/helpCenterDetail?wordNo=YSZC"
        },
        {
          title: "用户注册协议",
          url: "https://www.fuzhiqiangqi.com/helpCenterDetail?wordNo=YHZCXY"
        },
        {
          title: "注销协议",
          url: "https://www.fuzhiqiangqi.com/helpCenterDetail?wordNo=ZXXY"
        }
      ],
      tel: "17398495477",
      email: "jing.li@kocel.com",
      code: require("../../assets/code.png"),
      connectList: [
        {
          title: "宁夏企业公共服务平台",
          url: "https://www.smenx.com.cn/index.shtml"
        },
        {
          title: "银川工业互联网平台",
          url: "http://www.ycgydn.cn/"
        },
        {
          title: "菲麦森工业云平台",
          url: "https://industry.wzyb.com.cn/calc/home/index.page"
        },
        {
          title: "铸造云",
          url: "https://www.zhuzaocloud.com/"
        },

      ],
      baUrl: 'https://beian.miit.gov.cn/#/Integrated/index'
    };
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {
    this.getXWZX();
    this.getTSFW();
    this.getGGFW();
  },
  methods: {
    otherUrl(url) {
      window.open(url, "_blank");
    },
    /* 获取新闻资讯 */
    getXWZX() {
      this.xwzx = [];
      getNewsProgramTreeList({
        ignoreOrigin: "ASSOCIATION",
        current: 1,
        pageSize: 10
      }).then(res => {
        res.map((el, index) => {
          this.xwzx.push({ name: el.title, index });
        });
        this.xwzx.push({
          name: "赛事活动",
          index: "sshd"
        });
      });
    },
    /* 获取特色服务 */
    getTSFW() {
      this.tsfw = [];
      getTypeCount({
        status: "1",
        type: "SPECIAL_SERVICE"
      }).then(res => {
        if (Object.keys(res).length > 0) {
          this.tsfw = res.list;
        }
      });
    },
    /* 获取公共服务 */
    getGGFW() {
      this.ggfw = [];
      getTypeCount({
        status: "1",
        type: "COMMON_SERVICE"
      }).then(res => {
        if (Object.keys(res).length > 0) {
          this.ggfw = res.list;
        }
      });
    },
    /* 点击新闻资讯 */
    clickXWZX(index) {
      if (index == "sshd") {
        this.createRoute("activeList", {});
      } else {
        this.createRoute("newsConsult", { index });
      }
    },
    /* 点击创新服务下的某个名称 */
    clickCXFW(code) {
      this.createRoute("innovateService", { code });
    },
    /* 点击资源池 */
    clickZYC(code) {
      if (code == "2") {
        this.createRoute("resourcePool", { code });
      } else {
        this.createRoute("providerList", { code });
      }
    },
    /* 点击公共服务 */
    clickGGFW(uuid) {
      this.createRoute("digServiceList", { type: "common", uuid });
    },
    /* 点击特色服务 */
    clickTSFW(uuid) {
      this.createRoute("digServiceList", { type: "special", uuid });
    },
    /* 点击人才服务 */
    clickRCFW(code) {
      switch (code) {
        case "1":
          this.createRoute("onlineCourseList");
          break;
        case "2":
          this.createRoute("trainingCourseList");
          break;
        case "3":
          window.open("http://222.75.70.73:8001/zcps/", "_blank");
          break;
        case "4":
          this.createRoute("trainingCourseList");
          break;
      }
    },
    /* 点击企业诊断 */
    clickQYZD(code) {
      switch (code) {
        case "1":
          window.open("https://www.c3mep.cn/login", "_blank");
          break;
        case "2":
          window.open("https://nxpg.cspiii.com/userLogin", "_blank");
          break;
        case "3":
          this.createRoute("cloudUp");
          break;
        case "4":
          this.createRoute("diagnosisVLList");
          break;
      }
    },
    /* 创建路由 */
    createRoute(path, params) {
      let router = this.$router.resolve({
        path: `/${path}`,
        query: {
          ...params
        }
      });
      window.open(router.href, "_blank");
    }
  }
};
</script>
<style lang="less" scoped>
.newFooter {
  width: 100%;
  height: 570px;
  background-color: #2c3c4b;
  .curp {
    cursor: pointer;
    &:hover {
      // color: #2d50a1;
    }
  }
  .newFooter-con-top {
    width: 1300px;
    height: 355px;
    margin: 0 auto;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    align-content: start;

    .con-left {
      width: 950px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-around;
      align-items: start;
      box-sizing: border-box;
      padding-top: 40px;
      color: #fff;

      .con-left-item {
        .con-left-item-title {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 20px;
        }

        .con-left-item-sub {
          font-size: 14px;
          margin-bottom: 20px;
          cursor: pointer;
        }
      }
    }

    .devideLine {
      //width: 1px;
      height: 310px;
      margin-top: 40px;
      border-right: 1px solid #a9a2a24d;
      // background-color: #d3d3d3;
      border-radius: 2px;
    }

    .con-right {
      width: 290px;
      box-sizing: border-box;
      padding-top: 40px;
      color: #fff;

      .con-right-title {
        font-size: 16px;
        font-weight: 600;
        margin-bottom: 20px;
      }

      .con-right-sub {
        font-size: 14px;
        margin-bottom: 20px;
      }

      .con-right-code {
        width: 131px;
        height: 131px;
        background-size: 100% 100%;
        background-repeat: no-repeat;
      }

      .attention {
        font-size: 16px;
        font-weight: 600;
        margin-left: 20px;
        margin-top: 20px;
      }
    }
  }

  .newFooter-con-center {
    align-items: center;
    white-space: pre-wrap;
    color: #fff;
    font-size: 14px;
    // font-weight: 600;
    width: 1300px;
    margin: 0 auto;
    span {
      margin: 0 10px;
    }
  }

  .newFooter-con-bottom {
    height: 100px;
    width: 100%;
    border-top: 1px solid #a9a2a24d;
    color: #fff;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-around;
    align-items: center;
    font-size: 14px;

    .mark1 {
      display: flex;

      div {
        margin: 0 30px;
      }
    }

    .mark2 {
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/newFooter.vue